import { Outlet } from "react-router-dom";
import { useThemes } from "../../hooks/themeHooks";

export function ProcessTheme() {
  const { data: themes } = useThemes();

  if (themes) return <Outlet context={{ themes }} />;
  return null;
}
